import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-exportar',
    templateUrl: './exportar-dialog.html',
    styleUrls: ['./exportar-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlertaExportarDialog {
    uid;

    constructor(
        private dialogRef: MatDialogRef<AlertaExportarDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { bPDF: boolean, bExcel: boolean, bCSV: boolean }
    ) {
        this.uid = localStorage.getItem('uid')
    }

    exportar(tipo) {
        this.dialogRef.close({ tipo: tipo });
    }
}
